<template>
   <div class="app_header">
      <div class="app_headRig">
        <div class="app_headTit">云剪辑</div>
      <div class="app_headInp">
          <el-input placeholder="请输入内容" v-model="headInput">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        
      </div>
      <div class="app_headList">
<!--        <router-link to="/message" class="app_headItem">-->
<!--          <el-badge is-dot class="item">-->
<!--              <i class="el-icon-chat-dot-round"></i>-->
<!--            </el-badge>-->
<!--        </router-link>-->
<!--        <router-link to="/message" class="app_headItem">-->
<!--          <el-badge is-dot class="item">-->
<!--              <i class="el-icon-bell"></i>-->
<!--            </el-badge>-->
<!--        </router-link>-->
          <div class="app_headImgBox">
            <div class="app_headImg">
              <img :src="usertx" alt="">
            </div>
            <i class="el-icon-arrow-down"></i>
            <div class="app_headTbox">
              <div class="app_headTItem" @click="touser">
                个人中心
              </div>
              <div class="app_headTItem" @click="exit">
                退出登录
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'MyHeader',
  props: {
  },
  data() {
    return {
      headInput: '',
      messageShow:false,
      usertx:''
    }
  },
  mounted() {
    this.fetchTableData();
  },
  methods: {
    fetchTableData() {
      axios.get(this.$store.state.apiUrl+'/?a=ajax_select&m=usertx')
          .then(response => {
            // 处理成功情况
            this.usertx = response.data.tx;
            console.log(response)
            console.log(this.usertx)
          })
          .catch(error => {
            // 处理错误情况
            console.error("There was an error!", error);
          });

    },
    touser(){
      this.$router.push('usercenter');
    },
    exit() {
        this.$confirm('确认退出当前用户？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          axios.post(this.$store.state.apiUrl+'/?a=ajax_user&m=out')
              .then(response => {
                this.$message({
                  type: 'success',
                  message: '退出成功!'
                });
                this.$router.push("/index");
              })
              .catch(error => {
                // 处理错误情况
                console.error("There was an error!", error);
              });

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出'
          });          
        });
      }
  }
}
</script>

<style scoped>
/* 头部 */
.app_header {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.app_headTit {
  font-size: 20px;
  font-weight: 600;
}

.app_headInp {
  width: 350px;
  margin-left: 10px;
  overflow: hidden;
}
.app_headRig {
  width: 50%;
  display: flex;
  align-items: center;
}

.app_headList {
  display: flex;
  align-items: center;
}

.app_headItem {
  margin-right: 30px;
}

.app_headItem i {
  font-size: 20px;
}

.app_headImgBox {
  position: relative;
  display: flex;
  align-items: center;
}

.app_headImg {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.app_headImg img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.app_headImgBox i {
  font-size: 16px;
  margin-left: 10px;
}
.app_headTbox{
  width: 100px;
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 10px 0;
  opacity: 0;
  transition: all 0.48s;
  box-shadow: 0 0 10px rgba(0, 0, 0, .1);
}
.app_headTItem{
  width: 100%;
  text-align: center;
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.48s;
}
.app_headTItem:hover{
  background: rgb(255, 80, 0, .2);
  /* color: #fff; */
}
.app_headImgBox:hover .app_headTbox{
  opacity: 1;
  top:calc(100% - 2px);
}
.messageBox{
  z-index: 3000;
}
</style>